import styled from '@emotion/styled';
import { Button, Dialog, Typography } from '@taleemabad/dsm/components';
import { PropsWithChildren } from 'react';
export interface NoInternetDialogProps extends PropsWithChildren {
  title: string;
  description: string;
  showPopup: boolean;
  secondaryButton?: boolean;
  primaryButton?: boolean;
  primaryButtonText?: string;
  secondaryButtonText?: string;
  hasBackdrop?: boolean;
  iconName?: string;
  onPrimaryButtonClick?: () => void;
  onSecondaryButtonClick?: () => void;
  onClosePopup: () => void;
  primaryButtonDataCy?: string;
  secondaryButtonDataCy?: string;
}

export const AlertDialog = ({
  title,
  description,
  showPopup,
  children,
  secondaryButton = false,
  primaryButton = true,
  hasBackdrop = true,
  iconName,
  primaryButtonText = 'Got It',
  secondaryButtonText = 'Cancel',
  onPrimaryButtonClick,
  onSecondaryButtonClick,
  onClosePopup,
  primaryButtonDataCy = 'edit-day-dialog-continue-btn',
  secondaryButtonDataCy = 'edit-day-dialog-cancel-btn',
}: NoInternetDialogProps) => {
  return (
    <Dialog
      open={showPopup}
      hasBackdropClick={hasBackdrop}
      title={title}
      iconName={iconName}
      data-cy="edit-day-dialog-title"
      onClose={() => {
        onClosePopup();
      }}
    >
      <Typography variant="textBodyMedium">{description} </Typography>
      {children}
      <StyledPopupButton>
        {secondaryButton && (
          <Button
            variant="outlined"
            children={secondaryButtonText}
            data-cy={secondaryButtonDataCy}
            onClick={() => {
              onSecondaryButtonClick?.();
            }}
          />
        )}
        {primaryButton && (
          <Button
            children={primaryButtonText}
            data-cy={primaryButtonDataCy}
            onClick={() => {
              onPrimaryButtonClick?.();
              onClosePopup();
            }}
          />
        )}
      </StyledPopupButton>
    </Dialog>
  );
};

const StyledPopupButton = styled.div`
  margin-top: 24px;
  display: flex;
  align-items: end;
  gap: var(--rk-spacing-xl);
  justify-content: flex-end;
  @media (max-width: 400px) {
    flex-wrap: wrap;
    md-filled-button,
    md-outlined-button {
      width: auto;
      white-space: normal;
    }
  }
  md-filled-button {
    width: 100%;
  }
  md-outlined-button {
    width: 100%;
  }
`;
